import { Div } from "@tblabs/truffle";
import { Hero } from "../Components/Hero";
import { FaqSection } from "../../Components/Description/Faq/FaqSection";
import { AboutUsSection } from "../Components/AboutUs";
import { ContactBox } from "../Components/ContactBox";
import { CategoriesBox } from "./CategoriesBox";
import { AdminMenu } from "../../Components/Admin/AdminMenu";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { PageFooter } from "./PageFooter";


export class MainPage extends Div
{
    constructor(private _shop: ShopContentProvider)
    {
        super();
    }

    protected async OnAppend(): Promise<void>
    {
        await this._shop.Load();

        this.Append(
            new Hero(),
            this._shop.IsAuthorized && new AdminMenu({
                "Edytuj stronę": "page/edit",
                "Edytuj kategorie": "categories/edit",
            }),
            new CategoriesBox(this._shop),
            new AboutUsSection(this._shop),
            new FaqSection(this._shop),
            new ContactBox(),
            new PageFooter(this._shop),
        )
    }
}